const num = (min: number, max: number) => new Intl.NumberFormat("de-DE", { minimumFractionDigits: min, maximumFractionDigits: max });
const MONTHS = ["Jänner", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
const pad = (n: number) => String(n).padStart(2, "0");

export function hours(minutes: number): string {
  return `${num(2, 2).format(minutes / 60)} h`;
}

export function eur(amount: number, digits = 2): string {
  return `${num(digits, digits).format(amount)} €`;
}

export function date(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split("-");
  return d && m && y ? `${d}.${m}.${y}` : iso;
}

export function pct(v: number): string {
  return `${num(0, 2).format(v)} %`;
}

export function monthLabel(ym: string): string {
  const [y, m] = ym.split("-").map(Number);
  return m >= 1 && m <= 12 ? `${MONTHS[m - 1]} ${y}` : ym;
}

export function currentMonth(now = new Date()): string {
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}`;
}

export function today(now = new Date()): string {
  return `${currentMonth(now)}-${pad(now.getDate())}`;
}

export function shiftMonth(ym: string, delta: number): string {
  const [y, m] = ym.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return currentMonth(d);
}

/**
 * "1.234,5" (German) or "12.5" (plain) -> number; blank or garbage -> null. Without a comma, dots between groups of
 * exactly three digits are thousands separators when the first group does not start with 0: "1.000" is a thousand,
 * "2.5" stays two and a half, "0.250" stays a quarter.
 */
export function parseNumber(text: string): number | null {
  const t = text.trim();
  if (!t) return null;
  // A thousands group never starts with 0: „0.250“ is a quarter, not 250.
  const grouped = /^[1-9]\d{0,2}(\.\d{3})+$/.test(t);
  const normalized = t.includes(",") ? t.replaceAll(".", "").replace(",", ".") : grouped ? t.replaceAll(".", "") : t;
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
}

/** Local calendar day ("2026-11-03") of an ISO timestamp. */
export function localDate(iso: string): string {
  return today(new Date(iso));
}

/** Local wall-clock time ("14:07") of an ISO timestamp. */
export function clock(iso: string): string {
  const d = new Date(iso);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

const WEEKDAYS = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];

/** "Dienstag, 28. Oktober" for a "YYYY-MM-DD" day; the year only when it isn't the current one. */
export function longDate(day: string, now = new Date()): string {
  const [y, m, d] = day.split("-").map(Number);
  const weekday = WEEKDAYS[new Date(y, m - 1, d).getDay()];
  return `${weekday}, ${d}. ${MONTHS[m - 1]}${y === now.getFullYear() ? "" : ` ${y}`}`;
}
